// Service to check authentication for user and to signOut
import Storage from 'shared/helpers/storage'
import { parseJwt } from 'shared/helpers/functional'
import Cookie from 'js-cookie'

const Auth = {
  signOut() {
    const accessToken = Cookie.get('accessToken')
    const tokenDecoded = accessToken && parseJwt(accessToken)
    const isInCrowdAnyAdmin = tokenDecoded ? (tokenDecoded['cognito:groups'].includes('SUPER_ADMIN') || tokenDecoded['cognito:groups'].includes('ADMIN')) : false
    const isIncrowdAdminLogin = Cookie.get('isIncrowdAdminLogin') // we check if the user used Cognito login or no 

    Storage.removeItem("accessToken")
    Storage.removeItem("x-api-key")

    const cognitoLogoutUrl = `${process.env.REACT_APP_COGNITO_DOMAIN}/logout?client_id=${process.env.REACT_APP_COGNITO_CLIENT}&response_type=code&state=STATE&redirect_uri=${process.env.REACT_APP_COGNITO_REDIRECT}`
    const logoutRedirection = (isInCrowdAnyAdmin && isIncrowdAdminLogin) ? cognitoLogoutUrl : `${window.location.origin}/`
    window.location = logoutRedirection

  },
  isAuth() {
    if (Storage.getItem("accessToken")!== null) return true
    return false
  }
};

export default Auth;
